function RegularEvents() {
   return (
    
      <div className="page-container">
          <h1 className="page-title">Regular Events @ Gothenburg</h1>

          <div className="page-content">
            <p>
            To be updated!
            </p>

          </div>
        </div>

  );
}
export default RegularEvents;